import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
    || Element.prototype.webkitMatchesSelector;
}
